
export function arrayAppend<T>(arr: T[], items: T[]): number {
    return Array.prototype.push.apply(arr, items);
}
